// extracted by mini-css-extract-plugin
module.exports = {"global":"Global_global__a8rll"};